import { useEffect, useState } from "react";
import {
  EnumAlertDialogType,
  PopupInfoModel,
  ReportDetailModel,
  ReportModel,
  ShiftLogModel,
  ShiftPlanModel,
} from "../Managers/dataStructures";
import { timeout, updateShiftLog } from "../Managers/wepApiManager";
import {
  ActivityIndicator,
  NegativeToast,
  PositiveToast,
} from "../Managers/utilityComponents";
import ReportDetail from "../Reports/ReportDetail";
import { processGetReportDetail } from "../Managers/processManager";
import { getCurrentUser } from "../Managers/profileManager";
import { dateToString } from "../Managers/utilityFunctions";
import { getLanguage } from "../Managers/dataProvider";

interface BMReportDetailProps {
  item: PopupInfoModel;
  closeDialog: () => void;
}

export default function BMReportDetail(props: BMReportDetailProps) {
  const isEnglish = getLanguage();
  const [report, setReport] = useState<ReportModel>(props.item.props);
  const [array_reports, setArrayReports] = useState<ReportDetailModel[]>([]);
  const [comment, setComment] = useState<string>(
    report.shift_plan?.log !== undefined ? report.shift_plan?.log?.comments : ""
  );
  const [isReportSent, setIsReportSent] = useState<boolean>(false);
  const [activityIndicator, setActivityIndicator] = useState<boolean>(false);
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const [isToastVisible, setIsToastVisible] = useState<EnumAlertDialogType>(
    EnumAlertDialogType.NEUTRAL
  );

  const isInteractionDisabled: boolean =
    activityIndicator || isReportSent || isRunning;

  useEffect(() => {
    if (report.shift_plan === undefined) {
      return;
    }
    setIsRunning(true);
    processGetReportDetail(
      report.shift_plan,
      (
        shift_plan: ShiftPlanModel,
        array_reportDetail: ReportDetailModel[],
        total_hours_: string
      ) => {
        setIsRunning(false);
        let temp_report = report;
        temp_report.shift_plan = shift_plan;
        report.department = getCurrentUser().permanant_branch.name;
        report.total_hours = total_hours_;
        setReport(temp_report);
        setArrayReports(array_reportDetail);
        if (
          temp_report.shift_plan.log !== undefined &&
          temp_report.shift_plan.log.approved_by_user_id !== null
        ) {
          if (temp_report.shift_plan.log.approved_by_user_id > "-1") {
            setIsReportSent(true);
          }
        }
      }
    );
  }, []);

  function approveAndSend() {
    if (activityIndicator === true) {
      return;
    }
    let report_log = report.shift_plan?.log;
    if (report_log === undefined) {
      return;
    }
    report_log.approval_status = true;
    report_log.approved_by_user_id = getCurrentUser().user_id;
    report_log.comments = comment;
    setActivityIndicator(true);
    updateShiftLog(report_log, (isSuccess, shift_log: ShiftLogModel) => {
      setActivityIndicator(false);
      if (isSuccess) {
        showAlert(true, () => {
          if (props.item.callback !== undefined) {
            props.item.callback(props.item);
          } else {
            props.closeDialog();
          }
        });
        let tempReport = report;
        if (tempReport.shift_plan !== undefined) {
          tempReport.shift_plan.log = shift_log;
          setReport(tempReport);
          setIsReportSent(true);
        }
      } else {
        showAlert(false, () => {});
      }
    });
  }

  function onComment(value: string) {
    setComment(value);
  }

  function onCancel() {
    props.closeDialog();
  }

  async function showAlert(isPositive: boolean, callback: () => void) {
    if (isPositive) {
      setIsToastVisible(EnumAlertDialogType.POSITIVE);
    } else {
      setIsToastVisible(EnumAlertDialogType.NEGATIVE);
    }
    await timeout(3000);
    setIsToastVisible(EnumAlertDialogType.NEUTRAL);
    callback();
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {isEnglish ? "Report Detail" : "Filialtagesbericht"}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {isEnglish
              ? "Branch Manager must approve this report and send. He can add any observations in comment section."
              : "Der Schichtleiter wird gebeten, die Mitarbeiter und deren Arbeitszeiten zu überprüfen. Anschließend sollte er neben seinen Anmerkungen bitte auch seinen Namen, das Datum und den Vermerk 'Schicht freigegeben' ergänzen."}
          </p>
        </div>
        <button
          onClick={onCancel}
          type="button"
          className="block rounded-md mt-5  px-3 py-2 text-center text-sm font-semibold text-white shadow-sm bg-red-600 hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          //className="text-sm mt-5 font-semibold leading-6 text-white block rounded-md shadow-sm bg-red-600 hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
        >
          {isEnglish ? "Back" : "Zurück"}
        </button>
      </div>
      <div className="mt-5">
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {isEnglish ? "Report: Daily Branch" : "Filialtagesbericht"}
        </label>
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {/* {"Date: " + dateToString(report.date as Date)} */}
          {(isEnglish ? "Date: " : "Datum: ") +
            dateToString(report.date as Date)}
        </label>
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {(isEnglish ? "Branch: " : "Filiale: ") + report.department}
        </label>
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {(isEnglish ? "Branch manager: " : "Branch manager: ") +
            getCurrentUser().first_name +
            " " +
            getCurrentUser().last_name}
        </label>
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {(isEnglish ? "Total hours: " : "Gesamtarbeitsstunden: ") +
            report.total_hours}
        </label>
      </div>
      <div className="col-span-full mt-4">
        <label
          htmlFor="about"
          className="block text-sm font-medium leading-6 text-gray-900"
        >
          {isEnglish
            ? "Branch Manager's Comments"
            : "Bitte tragen Sie im Feld ihre Anmerkungen und Kommentare zur Schicht ein."}
        </label>
        <div className="mt-2">
          <textarea
            id="comment"
            name="comment"
            disabled={isInteractionDisabled}
            rows={3}
            onChange={(x) => onComment(x.currentTarget.value)}
            defaultValue={comment}
            className="block w-full rounded-md border-0 py-1.5 pl-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          ></textarea>
        </div>

        <div className="mt-4 sm:mt-0 sm:flex-none flex items-center gap-x-6">
          {isInteractionDisabled ? null : (
            <button
              type="button"
              disabled={isInteractionDisabled}
              onClick={approveAndSend}
              className="block rounded-md mt-5 bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              {activityIndicator === true ? ActivityIndicator(0) : null}
              {isEnglish ? "Approve and Send" : "Freigeben und senden"}
            </button>
          )}
        </div>
        {isToastVisible === EnumAlertDialogType.NEUTRAL
          ? null
          : isToastVisible === EnumAlertDialogType.POSITIVE
          ? PositiveToast(
              isEnglish
                ? "Report Successfully Signed and Sent"
                : "Arbeitszeiten freigegeben und gespeichert."
            )
          : NegativeToast(
              isEnglish
                ? "Error: Unable to process request."
                : "Fehler: Anforderung konnte nicht verarbeitet werden."
            )}
      </div>
      {isRunning ? (
        <div className="mt-5 flex items-center justify-center">
          {ActivityIndicator(1)}
        </div>
      ) : null}
      <ReportDetail
        array_reportDetail={array_reports}
        title={""}
        date={undefined}
      />
    </div>
  );
}
